(function () {
  'use strict';

  function parseJson(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function getLinkDefault(root) {
    var el = root.querySelector('[data-nr-wear-nothing-link-default]');
    if (!el) return 'view more';
    return parseJson(el.textContent, 'view more') || 'view more';
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function playVideo(video) {
    if (!video) return;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* autoplay blocked */
      });
    }
  }

  function whenPhotoSwipe(callback) {
    if (window.NrPhotoSwipe && window.NrPhotoSwipe.PhotoSwipeLightbox) {
      callback();
      return;
    }
    document.addEventListener('nr:photoswipe-ready', function () {
      callback();
    }, { once: true });
  }

  function initWearNothing(root) {
    if (root.dataset.nrWearNothingInit) return;
    root.dataset.nrWearNothingInit = 'true';

    var track = root.querySelector('[data-nr-wear-nothing-track]');
    var trackNextBtn = root.querySelector('[data-nr-wear-nothing-track-next]');
    var chrome = root.querySelector('[data-nr-wear-nothing-chrome]');
    var slides = Array.from(root.querySelectorAll('[data-nr-wear-nothing-slide]'));
    if (!slides.length || !chrome) return;

    var linkDefault = getLinkDefault(root);
    var imageCache = new Map();
    var lightbox = null;
    var lastTrigger = null;

    var modalCaption = chrome.querySelector('[data-nr-wear-nothing-caption]');
    var modalLink = chrome.querySelector('[data-nr-wear-nothing-link]');
    var atcImage = chrome.querySelector('[data-nr-wear-nothing-atc-image]');
    var atcTitle = chrome.querySelector('[data-nr-wear-nothing-atc-title]');
    var atcBtn = chrome.querySelector('[data-nr-wear-nothing-atc-btn]');

    function getThumbVideos() {
      return Array.from(root.querySelectorAll('[data-nr-wear-nothing-thumb-video]'));
    }

    function pauseAllThumbVideos() {
      getThumbVideos().forEach(pauseVideo);
    }

    function playAllThumbVideos() {
      if (window.pswp) return;
      getThumbVideos().forEach(playVideo);
    }

    function preloadImage(url) {
      if (!url) return;
      if (imageCache.has(url)) return;
      var img = new Image();
      img.src = url;
      imageCache.set(url, true);
    }

    function preloadSlide(slideEl) {
      if (!slideEl) return;
      if ((slideEl.dataset.mediaType || 'image') === 'image') {
        preloadImage(slideEl.dataset.imageSrc);
      }
    }

    function slideNumber(slideEl, fallback) {
      var value = Number(slideEl.dataset.mediaWidth || slideEl.dataset.mediaHeight ? slideEl.dataset.mediaWidth : 0);
      if (fallback === 'height') {
        value = Number(slideEl.dataset.mediaHeight || 0);
        return value > 0 ? value : 1600;
      }
      value = Number(slideEl.dataset.mediaWidth || 0);
      return value > 0 ? value : 1200;
    }

    function thumbElement(slideEl) {
      return slideEl.querySelector('.nr-wear-nothing__img, .nr-wear-nothing__video');
    }

    function buildItem(slideEl) {
      var mediaType = slideEl.dataset.mediaType || 'image';
      var thumb = thumbElement(slideEl);
      var width = slideNumber(slideEl, 'width');
      var height = slideNumber(slideEl, 'height');
      var item = {
        width: width,
        height: height,
        alt: slideEl.getAttribute('aria-label') || '',
        element: thumb || slideEl,
        thumbCropped: true,
        slideEl: slideEl,
        mediaType: mediaType,
      };

      if (mediaType === 'video') {
        item.type = 'html';
        item.videoSources = parseJson(slideEl.dataset.videoSources, []);
        if (thumb && thumb.poster) item.msrc = thumb.poster;
        return item;
      }

      item.src = slideEl.dataset.imageSrc || '';
      if (thumb) item.msrc = thumb.currentSrc || thumb.src || '';
      return item;
    }

    function buildDataSource() {
      return slides.map(buildItem);
    }

    function parkChrome() {
      chrome.hidden = true;
      root.appendChild(chrome);
    }

    function viewerPadding(viewportSize) {
      var mobile = viewportSize.x <= 749;
      var bottom = mobile ? 188 : 156;
      var pswp = lightbox && lightbox.pswp;
      var bar = pswp && pswp.element
        ? pswp.element.querySelector('.pswp__nr-bar')
        : null;
      if (bar) {
        var measured = Math.ceil(bar.getBoundingClientRect().height);
        if (measured > 48) bottom = measured + 12;
      }
      return {
        top: mobile ? 72 : 64,
        bottom: bottom,
        left: mobile ? 0 : 64,
        right: mobile ? 0 : 64,
      };
    }

    function updateChrome(slideEl) {
      if (!slideEl) return;

      var caption = slideEl.dataset.caption || '';
      if (caption) {
        modalCaption.textContent = caption;
        modalCaption.title = caption;
        modalCaption.hidden = false;
      } else {
        modalCaption.textContent = '';
        modalCaption.removeAttribute('title');
        modalCaption.hidden = true;
      }

      var linkUrl = slideEl.dataset.linkUrl || '';
      if (modalLink) {
        if (linkUrl) {
          modalLink.href = linkUrl;
          modalLink.textContent = slideEl.dataset.linkLabel || linkDefault;
        } else {
          modalLink.removeAttribute('href');
          modalLink.textContent = '';
        }
        modalLink.hidden = true;
      }

      if (atcImage) {
        var productImage = slideEl.dataset.productImage || '';
        if (productImage) {
          atcImage.src = productImage;
          atcImage.alt = slideEl.dataset.productTitle || '';
          atcImage.hidden = false;
        } else {
          atcImage.removeAttribute('src');
          atcImage.hidden = true;
        }
      }

      if (atcTitle) {
        atcTitle.textContent = slideEl.dataset.productTitle || '';
      }

      if (atcBtn) {
        var available = slideEl.dataset.productAvailable === 'true';
        atcBtn.disabled = !available;
        atcBtn.dataset.variantId = slideEl.dataset.productVariantId || '';
        atcBtn.dataset.productIsCurrent = slideEl.dataset.productIsCurrent || 'false';
      }
    }

    function syncVideos(pswp) {
      if (!pswp || !pswp.element) return;
      pswp.element.querySelectorAll('.nr-pswp-video__el').forEach(pauseVideo);
      var current = pswp.currSlide && pswp.currSlide.content && pswp.currSlide.content.element;
      if (!current) return;
      playVideo(current.querySelector('video'));
    }

    function refreshLayout(pswp) {
      if (!pswp) return;
      window.requestAnimationFrame(function () {
        if (!pswp.element || !pswp.element.isConnected) return;
        pswp.updateSize(true);
      });
    }

    function mountVideo(content) {
      var wrap = document.createElement('div');
      wrap.className = 'nr-pswp-video';
      var video = document.createElement('video');
      video.className = 'nr-pswp-video__el';
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      (content.data.videoSources || []).forEach(function (source) {
        var sourceEl = document.createElement('source');
        sourceEl.src = source.url;
        if (source.mime) sourceEl.type = source.mime;
        video.appendChild(sourceEl);
      });
      wrap.appendChild(video);
      content.element = wrap;
    }

    function ensureLightbox() {
      if (lightbox) return lightbox;
      var api = window.NrPhotoSwipe;
      if (!api || !api.PhotoSwipeLightbox || !api.PhotoSwipe) return null;

      lightbox = new api.PhotoSwipeLightbox({
        dataSource: buildDataSource(),
        pswpModule: function () {
          return api.PhotoSwipe;
        },
        mainClass: 'nr-pswp',
        bgOpacity: 1,
        showHideAnimationType: 'zoom',
        loop: slides.length > 1,
        paddingFn: function (viewportSize) {
          return viewerPadding(viewportSize);
        },
        closeOnVerticalDrag: true,
        pinchToClose: false,
        wheelToZoom: false,
        imageClickAction: 'zoom',
        tapAction: 'toggle-controls',
        bgClickAction: 'close',
        arrowPrev: slides.length > 1,
        arrowNext: slides.length > 1,
        counter: slides.length > 1,
        zoom: false,
        preload: [1, 2],
        spacing: 0.08,
        errorMsg: 'The photo could not be loaded',
      });

      lightbox.addFilter('thumbEl', function (thumbEl, data) {
        return (data && data.element) || thumbEl;
      });

      lightbox.on('contentLoad', function (event) {
        if (!event.content || !event.content.data || event.content.data.mediaType !== 'video') return;
        event.preventDefault();
        mountVideo(event.content);
      });

      lightbox.on('uiRegister', function () {
        var pswp = lightbox.pswp;
        if (!pswp) return;
        pswp.ui.registerElement({
          name: 'nr-bar',
          order: 12,
          isButton: false,
          appendTo: 'root',
          onInit: function (el) {
            chrome.hidden = false;
            el.appendChild(chrome);
            updateChrome(slides[pswp.currIndex]);
          },
        });
      });

      lightbox.on('change', function () {
        var pswp = lightbox.pswp;
        if (!pswp) return;
        updateChrome(slides[pswp.currIndex]);
        syncVideos(pswp);
        refreshLayout(pswp);
      });

      lightbox.on('slideActivate', function (event) {
        var slide = event && event.slide;
        var element = slide && slide.content && slide.content.element;
        if (!element) return;
        playVideo(element.querySelector('video'));
      });

      lightbox.on('slideDeactivate', function (event) {
        var slide = event && event.slide;
        var element = slide && slide.content && slide.content.element;
        if (!element) return;
        pauseVideo(element.querySelector('video'));
      });

      lightbox.on('loadComplete', function () {
        syncVideos(lightbox.pswp);
      });

      lightbox.on('destroy', function () {
        parkChrome();
        playAllThumbVideos();
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus({ preventScroll: true });
        }
      });

      lightbox.init();
      return lightbox;
    }

    function addToCartFromSlide(slideEl) {
      if (!slideEl || slideEl.dataset.productAvailable !== 'true') return;

      var isCurrent = slideEl.dataset.productIsCurrent === 'true';
      if (isCurrent) {
        var formBtn = document.querySelector(
          '.product-information [data-type="add-to-cart-form"] button[name="add"]:not([disabled])'
        );
        if (formBtn) {
          formBtn.click();
          return;
        }
      }

      var variantId = slideEl.dataset.productVariantId;
      if (!variantId) return;

      var cartAddUrl =
        (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) return;
          var cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
          return fetch(cartUrl + '.js').then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          if (!cart) return;
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart },
            })
          );
        })
        .catch(function () {
          /* ignore */
        });
    }

    function openModal(index, trigger) {
      lastTrigger = trigger || slides[index] || null;
      pauseAllThumbVideos();
      whenPhotoSwipe(function () {
        var box = ensureLightbox();
        if (!box || window.pswp) return;
        box.loadAndOpen(index, buildDataSource());
      });
    }

    if (track && trackNextBtn) {
      trackNextBtn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.6, behavior: 'smooth' });
      });
    }

    slides.forEach(function (slide, index) {
      slide.addEventListener('pointerenter', function () {
        preloadSlide(slide);
        preloadSlide(slides[(index + 1) % slides.length]);
        preloadSlide(slides[(index - 1 + slides.length) % slides.length]);
      });

      slide.addEventListener('click', function () {
        openModal(index, slide);
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        var pswp = lightbox && lightbox.pswp;
        var index = pswp ? pswp.currIndex : 0;
        addToCartFromSlide(slides[index]);
      });
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseAllThumbVideos();
        if (window.pswp && window.pswp.element) {
          window.pswp.element.querySelectorAll('.nr-pswp-video__el').forEach(pauseVideo);
        }
      } else if (!window.pswp) {
        playAllThumbVideos();
      } else {
        syncVideos(window.pswp);
      }
    });

    playAllThumbVideos();
    whenPhotoSwipe(function () {
      ensureLightbox();
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        slides.forEach(preloadSlide);
      });
    } else {
      setTimeout(function () {
        slides.forEach(preloadSlide);
      }, 300);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-nr-wear-nothing]').forEach(function (root) {
      if (root.hasAttribute('data-nr-wear-nothing-wall')) return;
      initWearNothing(root);
    });
  }

  window.NrWearNothing = {
    init: initWearNothing,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-nr-wear-nothing]').forEach(function (root) {
      if (root.hasAttribute('data-nr-wear-nothing-wall')) return;
      initWearNothing(root);
    });
  });
})();
